import { useCallback } from 'react'
import { useMeetingReactionsStore } from '@/features/meeting/store/meeting-reactions.store'

export function useReactions() {
  const reactionsByPeer = useMeetingReactionsStore((s) => s.reactionsByPeer)
  const triggerReaction = useMeetingReactionsStore((s) => s.triggerReaction)
  const clearReaction = useMeetingReactionsStore((s) => s.clearReaction)
  const clearAllReactions = useMeetingReactionsStore((s) => s.clearAll)

  /** The emoji to show on one participant's tile, or null. */
  const reactionFor = useCallback(
    (peerId: string | undefined | null) => (peerId ? reactionsByPeer[peerId] ?? null : null),
    [reactionsByPeer],
  )

  return {
    reactionsByPeer,
    reactionFor,
    triggerReaction,
    clearReaction,
    clearAllReactions,
  }
}
